// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3Xgdl","title":"ClientReferral_title__bG52T","itemText":"ClientReferral_itemText__2Ir1v"};